import TodoList from "./todo-list"
import {TODO_ITEM} from "./items/item"
import {TodoListAccess} from "./const";

export default class ActionItems {

    item    : any
    access  : TodoListAccess
    lists   : any

    constructor(item: any, access: TodoListAccess, serializedTodoLists: any[]) {
        this.item   = item
        this.access = access

        this.lists  = false
        this.normalize(serializedTodoLists)
    }

    reset(serializedTodoLists: any[]) {
        this.normalize(serializedTodoLists)
    }

    get completedTotal() {
        return this.getCompletedItemsCounter()
    }

    get uncompletedTotal() {
        return this.getUncompletedItemsCounter()
    }

    get total():number {
        return _.sumBy(this.lists, (list:any)=>list.length)
    }

    get progress():number {

        const total = this.total
        const completed = this.completedTotal

        if (!total) return 0

        return Math.floor(completed/total * 100)
    }

    // deprecated
    getCompletedItemsCounter() {
        return _.sumBy(this.lists, (list:any)=>list.completedItemsLength)
    }

    getUncompletedItemsCounter() {
        return _.sumBy(this.lists, (list:any)=>list.uncompletedItemsTotal)
    }

    getItemsCounter() {
        return _.sumBy(this.lists, (list:any)=>list.length)
    }

    normalize(data:any) {
        if (data && data.length>0) {
            this.lists = []

            const uids = _(data).map(todoListRaw=>todoListRaw.uid).compact().value()
            data.map((todoListRaw:any)=>{
                if (!todoListRaw.uid) {
                    todoListRaw.uid = gd.utils.generateUIDWithCollisionChecking(uids)
                    uids.push(todoListRaw.uid)
                }

                const todoList = new TodoList(this, todoListRaw)
                this.lists.push(todoList)
            })
        } else {
            this.lists = false
        }
    }

    get isEmpty() {
        return !this.lists || this.lists.length < 1
    }

    newEmptyTodoList() {
        let title = 'Todo List'

        if (this.lists && this.lists.length > 0) title += ' ' + (this.lists.length + 1)
        if (!this.lists) this.lists = []

        const uids = _.map(this.lists, list=>list.uid)

        const newTodoList = TodoList.create(this, {
            uid     : gd.utils.generateUIDWithCollisionChecking(uids),
            title   : title,
            items   : [],
        });

        this.lists.push(newTodoList)
    }

    newTodoListFromTemplate(callback:callback) {
        gd.modals.task.addTodoList(gd.companyId, (title:string, items:any[])=>{
            const found = _.find(this.lists, l=>l.title === title)
            if (found && this.lists && this.lists.length > 0) title += ' ' + (this.lists.length + 1)
            if (!this.lists) this.lists = []

            const uids:ID[] = _.map(this.lists, list=>list.uid)

            this.lists.push(TodoList.create(this, {
                uid     : gd.utils.generateUIDWithCollisionChecking(uids),
                title   : title,
                items   : items.map(todo=>({
                    type        : TODO_ITEM,
                    properties  : {title: todo}
                }))
            }))

            if (callback) callback()
        })
    }

    deleteTodoList(uid:ID) {_.remove(this.lists, (list:any)=>list.uid === uid)}

    toJSON = () => _.map(this.lists, todoList=>todoList.toJSON())
}